<template>
  <div v-if="isOpen" class="modal-overlay">
    <div class="modal-content">
      <div class="modal-header">
        <button @click="closeModal" class="close-btn">
          <img :src="closeImg">
        </button>
        <p>نتيجة الواجب</p>
      </div>

      <div v-if="message" class="text-center p-5">{{ message }}</div>
      <div class="d-flex flex-column result-content" v-else>
        <div class="d-flex">
          <span>الواجب: </span>
          <p>{{ homework_name }}</p>
        </div>
        <hr>
        <div class="d-flex">
          <span>درجة الواجب: </span>
          <p>{{ homework_marks }}</p>
        </div>
        <hr>
        <div class="d-flex">
          <span>درجتك: </span>
          <p>{{ student_marks }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiService from '@/apiService';

export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    homeworkId: {
      type: Number,
      required: true,
    }
  },
  data() {
    return {
      closeImg: require('@/assets/images/close-circle.svg'),
      homework_name: '',
      homework_marks: '',
      student_marks: '',
      message: '',
    };
  },
  watch: {
    isOpen(val) {
      if (val) {
        this.getHwResult();
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    async getHwResult() {
      try {
        const response = await apiService.getHwResult(this.homeworkId);
        this.message = '';
        this.homework_name = response.data.homework_name || [];
        this.homework_marks = response.data.homework_marks !== undefined ? response.data.homework_marks : '';
        this.student_marks = response.data.student_marks !== undefined ? response.data.student_marks : '';
      } catch (error) {
        if (error.response && error.response.status === 403 && error.response.data.message) {
          this.message = error.response.data.message;
        } else {
          this.message = 'Error fetching exam result. Please try again later.';
        }
      }
    },
  },
};
</script>

    
    <style scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .modal-content {
    background: white;
    border-radius: 10px;
    width: 500px;
    max-width: 90%;
  }
  
  .modal-header {
    display: flex;
    justify-content: flex-start;
    background: #FAAF43;
    border-radius: 10px 10px 0 0;
    gap: 27%;
    padding-top: 10px;
    /* padding: 0 10px; */
    padding-right: 10px;
  }
  .modal-header p{
    color: #FFF;

font-family: Cairo;
font-size: 22px;
font-style: normal;
font-weight: 700;
line-height: normal;
  }
  
  .close-btn {
    background: none;
    border: none;
    cursor: pointer;
    margin-bottom: 15px;
    padding: 0;
  }
  .close-btn img{
    width: 35px;
    height: 35px;
  }
.result-content{
    padding:20px 30px ;
}
  .result-content span{
    color: #FAAF43;

text-align: right;
font-family: Cairo;
font-size: 18px;
font-style: normal;
font-weight: 400;
line-height: normal;
width: 30%;
  }
  .result-content p{
    color: #000;
font-family: Cairo;
font-size: 20px;
font-style: normal;
font-weight: 500;
line-height: normal;
margin: 0;
  }
  </style>
    